import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Head from './basic/Head';
import Header from './basic/Header';
import Banner from './basic/Banner';
import Footer from './basic/Footer';
import Home from './Home';
import Games from './games/Games';
import RollingRush from './games/RollingRush';
import PlankSpin from './games/PlankSpin';
import BouncyBird from './games/BouncyBird';
import Toys from './toys/Toys';
import TempoFinder from './toys/TempoFinder';
import RandomByteGenerator from './toys/RandomByteGenerator';
import TimeConverter from './toys/TimeConverter';
import PrivacyPolicy from './PrivacyPolicy';
import LucyMod from './LucyMod';
import NotFound from './NotFound';

function App() {
  return (
    <Router>
      <div className="app">

        <div className="content">

          <Switch>

            <Route exact path="/">
              <Head title="Home" abbv={false}/>
              <Header />
              <Home />
            </Route>

            <Route exact path="/games">
              <Head title="Games" abbv={true}/>
              <Header />
              <Banner text="Games"/>
              <Games />
            </Route>

            <Route path="/games/rolling-rush">
              <Head title="Rolling Rush" abbv={true}/>
              <Header />
              <Banner text="Games"/>
              <RollingRush />
            </Route>

            <Route path="/games/plank-spin">
              <Head title="Plank Spin" abbv={true}/>
              <Header />
              <Banner text="Games"/>
              <PlankSpin />
            </Route>

            <Route path="/games/bouncy-bird">
              <Head title="Bouncy Bird" abbv={true}/>
              <Header />
              <Banner text="Games"/>
              <BouncyBird />
            </Route>

            <Route exact path="/toys">
              <Head title="Web Toys" abbv={true}/>
              <Header />
              <Banner text="Web Toys"/>
              <Toys />
            </Route>

            <Route path="/toys/tempo-finder">
              <Head title="Tempo Finder" abbv={true}/>
              <Header />
              <Banner text="Web Toys"/>
              <TempoFinder />
            </Route>

            <Route path="/toys/random-byte-generator">
              <Head title="Random Byte Generator" abbv={true}/>
              <Header />
              <Banner text="Web Toys"/>
              <RandomByteGenerator />
            </Route>

            <Route path="/toys/time-converter">
              <Head title="Time Converter" abbv={true}/>
              <Header />
              <Banner text="Web Toys"/>
              <TimeConverter />
            </Route>

            <Route path="/privacy-policy">
              <Head title="Privacy Policy" abbv={true}/>
              <Header />
              <Banner text="Hello!"/>
              <PrivacyPolicy />
            </Route>

            <Route path="/lucymod">
              <Head title="Lucy's Mod" abbv={true}/>
              <Header />
              <Banner text="Modding"/>
              <LucyMod />
            </Route>

            {/* <Route path="/play/rolling-rush">
              <Head title="Rolling Rush" abbv={true}/>
              <Header />
              
            </Route>

            <Route path="/play/plank-spin">
              <Head title="Plank Spin" abbv={true}/>
              <Header />
              
            </Route>

            <Route path="/play/bouncy-bird">
              <Head title="Bouncy Bird" abbv={true}/>
              <Header />
              
            </Route> */}

            <Route path="*">
              <Head title="Page not found" abbv={true}/>
              <Header />
              <Banner text="Oops"/>
              <NotFound />
            </Route>

          </Switch>

        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
